import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {LoginRequest} from "../../../core/authentication.actions";
import {loginInfo} from "../../../core/authentication.selectors";
import {Subject, takeUntil} from "rxjs";
import {Router} from '@angular/router';
@Component({
  selector: 'app-login-right-panel',
  templateUrl: './login-right-panel.component.html',
  styleUrls: ['../../../../shared/components/form-fields/styles.css', './login-right-panel.component.css']
})
export class LoginRightPanelComponent {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  errorMessages: any = {};
  suffixIcon = 'eye';
  showPassword = false;

  signInTooltipText = `If you have trouble signing into your account, try the following:`
    + `\n \u2022 Clear your browser's cookies and cache`
    + `\n \u2022 Close any other open HEALTHY tabs`
    + `\n \u2022 Try a different browser or device`
    + `\n \u2022 Reset your password using the "Forgot Password" link`
    + `\n \u2022 If you've forgotten your username, ask your coach, or refer to the email you received when you first created your account (subject: Stanford HEALTHY - Save this email!)`

  errorMessageMap = {
    username: {
      required: 'This field is required.'
    },
    password: {
      required: 'This field is required.'
    }
  }

  form = new FormGroup({
    username: new FormControl({value: '', disabled: false}, [Validators.required]),
    password: new FormControl({value: '', disabled: false}, [Validators.required]),
  })

  loading = false;

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private router: Router,
  ) {
    this.store.select(loginInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        if (this.loading) {
          this.form.disable({emitEvent: false});
        } else {
          this.form.enable({emitEvent: false});
        }
      })
  }

  login() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const {username, password} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const payload = {
      username : username.trim().toLowerCase(),
      password,
    };
    // ACTION DISPATCH
    this.store.dispatch(LoginRequest({payload}));
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  forgotPassword() {
    this.router.navigate(['/auth/password/forgot']);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword
    if (this.showPassword) {
      this.suffixIcon = 'eye-closed'
    } else {
      this.suffixIcon = 'eye'
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
